<script setup>
import { defineProps, onMounted, ref } from 'vue';

const props = defineProps({
    isImmediate: Boolean,
    timeVal: { // 分鐘倒數
        type: Number,
        default: 5,
    },
    beginCounting: Function,
    stopCounting: Function,
    buttonText: {
        type: String,
        default: '重新發送',
    },
    buttonDisabled: Boolean,
    inputValue: String,
    setInputValue: Function,
    inputSize: Number,
    inputdisabled: Boolean,
});

const timeVisible = ref(false);

let timer;
let entryTime = 0;  //頁面載入十的時間
let currentTime = 0; //紀錄計時器內的時間

let timeVal = props.timeVal; //分鐘倒數
let maxtime = timeVal * 60; // 換算秒
const msg = ref(timeVal + ':00');

const countDown = () => {
    currentTime = parseInt(new Date().getTime() / 1000); //紀錄計時器內的時間
    let timeDifference = (currentTime - entryTime);
    let mytime = maxtime - timeDifference;
    if (timeDifference <= maxtime) {
        let minutes = Math.floor(mytime / 60);
        let seconds = Math.floor(mytime % 60);
        msg.value = minutes + ':' + ((seconds < 10) ? '0' + seconds : seconds);

        // 一分鐘後解除按鈕的disabled
        if (timeDifference >= 60 && props.stopCounting && props.buttonDisabled) {
            props.stopCounting();
        }
    } else {
        clearInterval(timer);
        // isCounting.value = false;
        if (props.stopCounting) {
            props.stopCounting();
        }
    }
};

//歸零重新計算
const resetCountTime = () => {
    clearInterval(timer);
    entryTime = parseInt(new Date().getTime() / 1000);//頁面載入十的時間
    currentTime = 0; //紀錄計時器內的時間
    timer = setInterval(countDown, 1000);
};

const requestVerifyCode = () => {
    if (props.beginCounting) {
        props.beginCounting().then(res => {
            //歸零重新計算
            resetCountTime();

            if (!timeVisible.value) {
                timeVisible.value = true;
            }
        });
    }
};

onMounted(() => {
    if (props.isImmediate) {
        requestVerifyCode();
    }

});

</script>

<template>

    <div>
        <div class="flex justify-between items-center pb-2">
            <h3 class="font-bold text-xl">輸入動態密碼</h3>
            <div>
                <button class="text-[#0093C1] font-bold disabled:text-[#86878F]" :disabled="buttonDisabled"
                    @click="requestVerifyCode">{{
                        (timeVisible) ? buttonText :
                            '發送動態密碼'
                    }}
                </button>
            </div>
        </div>
        <slot v-if="$slots.default">
        </slot>
        <input type="text" :placeholder="'請輸入 ' + inputSize + ' 碼動態密碼'" :maxlength="inputSize" :size="inputSize"
            :disabled="inputdisabled" :value="inputValue" @input="(e) => { setInputValue(e.target.value) }" v-else />

        <p class="pt-2" v-show="timeVisible"> 動態密碼將在 <span class="text-[#EB4751]"> {{ msg }} </span> 分鐘後失效
        </p>

    </div>

</template>

<style scoped></style>
